import { useEffect, useState } from 'react';

export type FilterOption = {
  code: string;
  displayName: string;
};

interface Props {
  title?: string;
  categories: FilterOption[];
  selected: string[];
  onApply: (codes: string[]) => void;
  onClose: () => void;
}

export default function CategoryFilterSheet({
  title = '혜택 분야 선택',
  categories,
  selected,
  onApply,
  onClose,
}: Props) {
  const [draft, setDraft] = useState<string[]>(selected);

  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prev;
    };
  }, []);

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  const toggle = (code: string) => {
    setDraft(prev =>
      prev.includes(code) ? prev.filter(c => c !== code) : [...prev, code]
    );
  };

  const handleReset = () => setDraft([]);
  const handleApply = () => {
    onApply(draft);
    onClose();
  };

  return (
    <>
      <div className="bp-filter-backdrop" onClick={onClose} aria-hidden />
      <div className="bp-filter-sheet" role="dialog" aria-modal="true">
        <div className="bp-sheet-handle" />
        <h3 className="bp-filter-title">{title}</h3>

        <ul className="bp-filter-list">
          {categories.map(c => {
            const isChecked = draft.includes(c.code);
            return (
              <li key={c.code}>
                <button
                  type="button"
                  role="checkbox"
                  aria-checked={isChecked}
                  className="bp-filter-row"
                  onClick={() => toggle(c.code)}
                >
                  <span className="bp-filter-name">{c.displayName}</span>
                  <span
                    className={
                      isChecked
                        ? 'bp-mys-check bp-mys-check--on'
                        : 'bp-mys-check'
                    }
                    aria-hidden
                  >
                    {isChecked && (
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M5 12.5l4.5 4.5L19 7"
                          stroke="#fff"
                          strokeWidth="2.6"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    )}
                  </span>
                </button>
              </li>
            );
          })}
        </ul>

        <div className="bp-filter-actions">
          <button
            type="button"
            className="bp-filter-reset"
            onClick={handleReset}
            disabled={draft.length === 0}
          >
            초기화
          </button>
          <button
            type="button"
            className="bp-filter-apply"
            onClick={handleApply}
          >
            {draft.length > 0 ? `${draft.length}개 선택 적용` : '전체 보기'}
          </button>
        </div>
      </div>
    </>
  );
}
